import { useState, useEffect, useRef } from 'react';
import { getUserByFirebaseUid } from 'api/api';
import { useAuth } from 'contexts/AuthContext';

export function useGetUserRole(options = {}) {
  const { enabled = true } = options;
  const [role, setRole] = useState(null);
  const [isVIP, setIsVIP] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (!enabled) {
      if (mountedRef.current) {
        setRole(null);
        setIsVIP(false);
        setUserData(null);
        setLoading(false);
        setError(null);
      }
      return () => {
        controller.abort();
      };
    }

    if (mountedRef.current) {
      setLoading(true);
      setError(null);
    }

    if (user && user.uid) {
      getUserByFirebaseUid(user.uid, { signal })
        .then((data) => {
          if (mountedRef.current) setRole(data.role);
          if (mountedRef.current) setIsVIP(data.isVIP || false);
          if (mountedRef.current) setUserData(data);
          if (mountedRef.current) setLoading(false);
        })
        .catch((err) => {
          if (err.name !== 'CanceledError' && err.code !== 'ERR_CANCELED') {
            if (mountedRef.current) setError(err);
          }
          if (mountedRef.current) setLoading(false);
        });
    } else {
      if (mountedRef.current) setLoading(false);
    }

    return () => {
      controller.abort();
    };
  }, [user, enabled]);

  return { role, loading, error, isVIP, user: userData };
}
